/**
 * Interface language of the platform (Arabic / English). Static UI text only — content
 * entered by the platform (names, form texts) is bilingual in the data itself.
 * Switching saves the choice and reloads, so module-level tr() calls (label maps) are safe.
 */
export type UiLanguage = 'ar' | 'en';
export const UI_LANGUAGE_KEY = 'platform.uiLanguage';

export function getUiLanguage(): UiLanguage {
  try {
    const saved = typeof localStorage !== 'undefined' ? localStorage.getItem(UI_LANGUAGE_KEY) : null;
    if (saved === 'ar' || saved === 'en') return saved;
  } catch {
    /* storage unavailable */
  }
  return 'ar';
}

export function setUiLanguage(language: UiLanguage) {
  try {
    localStorage.setItem(UI_LANGUAGE_KEY, language);
  } catch {
    /* storage unavailable */
  }
}

export const isEn = () => getUiLanguage() === 'en';
/** tr('نص عربي', 'English text') — picks the interface language. */
export const tr = (arabic: string, english: string) => (isEn() ? english : arabic);
export const uiLocale = () => (isEn() ? 'en-US' : 'ar-JO-u-nu-latn');
export const uiDirection = (): 'ltr' | 'rtl' => (isEn() ? 'ltr' : 'rtl');

/** Display name of a data row in the interface language (English falls back to Arabic). */
export function nameOf(row: { name_ar?: string | null; name_en?: string | null; name?: string | null; nameEn?: string | null } | null | undefined): string {
  if (!row) return '';
  const ar = row.name_ar ?? row.name ?? '';
  const en = row.name_en ?? row.nameEn ?? null;
  return isEn() && en?.trim() ? en : ar;
}
